import * as React from 'react';
import { ISms } from '../../../Types';
import { Table } from 'react-bootstrap';
import { Translate } from '../../../../../../../shared/LanguageService';
import SmsListRow from './SmsListRow';

interface IProps {
    items: ISms[];
    viewDetails: (smsId: number) => void;
}

const SmsList = (props: IProps) => {
    return (
        <Table responsive>
            <thead>
                <tr className="table_header">
                    <th>
                        {Translate(
                            'view-order/basic-order-info/modal/view-sms/table-headers/recepient-role'
                        )}
                    </th>
                    <th>
                        {Translate(
                            'view-order/basic-order-info/modal/view-sms/table-headers/created'
                        )}
                    </th>
                    <th>
                        {Translate('view-order/basic-order-info/modal/view-sms/table-headers/sent')}
                    </th>
                    <th>
                        {Translate(
                            'view-order/basic-order-info/modal/view-sms/table-headers/failed'
                        )}
                    </th>
                </tr>
            </thead>
            <tbody>
                {props.items
                    .sort(
                        (a, b) =>
                            new Date(a.createdTime.localDateTime).getTime() -
                            new Date(b.createdTime.localDateTime).getTime()
                    )
                    .map((e: ISms) => {
                        return <SmsListRow item={e} key={e.id} onView={props.viewDetails} />;
                    })}
            </tbody>
        </Table>
    );
};

export default SmsList;
